module.exports = __webpack_public_path__ + "static/blog-placeholder-7ec8b495f19437df72587f54b3e801e8.png";